import React, {FunctionComponent} from "react";
import {FilePreviewerProps} from "../FilePreview";

export const DocumentPreview: FunctionComponent<FilePreviewerProps> = (props) => {
    const getDocumentViewerUrl = () => {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${props.file?.url}`;
    };

    const renderDocumentPreview = () => {
        return <object data={getDocumentViewerUrl()}>
            <embed src={getDocumentViewerUrl()}/>
        </object>;
    };

    return renderDocumentPreview();
};